import React from 'react';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import CustomButton from '../../../components/common/custom-button/custom-button.jsx';
import Text from '../../../components/common/custom-text/custom-text.jsx';

import styles from './downgrade-plan-dialog.module.scss';

function DowngradePlanDialog({
  open,
  setOpen,
  to,
  from,
  onContinue,
  onCancel,
  testId = 'downgrade-plan-dialog',
}) {
  var title = 'Keep Your Brand Front and Center';
  var description =
    "Downgrading to Freelancer means you'll lose your custom domain and branding. Don't worry though, you can upgrade anytime to get your white-label branding back.";
  var keepPlanButton = 'Keep my current plan';

  if (from === 'AGENCY' && to === 'TEAM') {
    title = "You're About to Lose Some Powerful Features!";
    description =
      "Team doesn't include Advanced White-Label branding, Paid Social Reporting, and other premium capabilities. You'll still have Standard White-Label branding and all the other core features.";
    keepPlanButton = 'Stay on Agency!';
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
      aria-labelledby="restart-registration-modal-title"
      aria-describedby="restart-registration-modal-description"
      data-testid={testId}
    >
      <DialogTitle
        id="restart-registration-modal-title"
        sx={{ padding: '20px 20px 8px 20px' }}
      >
        <Text variant="l1" as="h2">
          {title}
        </Text>
      </DialogTitle>
      <DialogContent
        id="restart-registration-modal-description"
        sx={{ padding: '0px 20px 24px 20px' }}
      >
        <div className={styles.textContainer}>
          <Text variant="b1" color="#4A4D52">
            {description}
          </Text>
        </div>
      </DialogContent>
      <DialogActions sx={{ padding: '0px 20px 20px 20px' }}>
        <div className={styles.buttonContainer}>
          <CustomButton
            variant="primary"
            onClick={onCancel}
            fullWidth
            data-testid={`${testId}-keep-plan-button`}
          >
            {keepPlanButton}
          </CustomButton>
          <CustomButton
            variant="secondary"
            color="danger"
            onClick={onContinue}
            fullWidth
            data-testid={`${testId}-downgrade-button`}
          >
            Confirm and downgrade
          </CustomButton>
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default DowngradePlanDialog;
